import { FreeformContent } from './FreeformContent';

export function FreeformParagraph({ text }) {
    return (
        <p>
            <FreeformContent>{text}</FreeformContent>
        </p>
    );
}
